export const environment = {
  production: false,
  selfUrl: 'https://frontend.essa.eveneum.com',
  mediaUrl: 'https://essa.eveneum.com',
  auctionServer: 'https://frontend.essa.eveneum.com:9006',
  api: {
    shoppingpanel: 'https://essa.eveneum.com/api',
  }
};
